import { useSpring, animated, type SpringValues } from '@react-spring/web';
import { ChevronLeftIcon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';

export const ClickableHeading = ({
  onClick,
  children,
}: {
  onClick: () => void;
  children: React.ReactNode;
}) => {
  const animatedProps = useSpring({
    from: { scale: 1, transformOrigin: 'left' },
    to: { scale: 0.6 },
    config: {
      tension: 180,
      friction: 18,
      duration: 200,
    },
  });

  return (
    <Clickable onClick={onClick} style={{ textAlign: 'left' }}>
      <Box flexDirection="row" alignItems="baseline" minWidth="100px">
        {/* To align icon to the bottom of the SVG container */}
        <Box top="3px">
          <ChevronLeftIcon size={6} />
        </Box>
        <Box
          as={animated.div}
          style={animatedProps as SpringValues}
          width="100%"
        >
          {children}
        </Box>
      </Box>
    </Clickable>
  );
};
